module.exports = __webpack_public_path__ + "img/by.ba5e4290.svg";